import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { resolveImage } from '@/lib/image';

export const MerchPreview = ({ products }) => {
    if (!products || products.length === 0) return null;

    return (
        <section
            data-testid="merch-preview-section"
            className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-brand-surface"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-end mb-12">
                    <div>
                        <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">NEW DROP</p>
                        <h2 className="font-syne font-bold text-4xl md:text-5xl text-white tracking-tight">
                            SHOP MERCH
                        </h2>
                    </div>
                    <Link to="/merch" className="hidden md:block">
                        <Button
                            variant="ghost"
                            className="text-slate-400 hover:text-white uppercase tracking-widest"
                        >
                            VIEW ALL <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </Link>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {products.map((product) => (
                        <Link
                            key={product.id}
                            to="/merch"
                            data-testid={`merch-preview-${product.id}`}
                            className="group"
                        >
                            <div className="relative aspect-square overflow-hidden bg-brand-highlight mb-4">
                                <img
                                    src={resolveImage(product.image_url)}
                                    alt={product.name}
                                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-100 group-hover:scale-105"
                                />
                                {product.featured && (
                                    <div className="absolute top-3 left-3 z-10 px-3 py-1.5 bg-white text-black font-mono text-[10px] uppercase tracking-widest rounded-full shadow-lg">
                                        <span className="inline-block w-1.5 h-1.5 bg-red-500 rounded-full mr-2 animate-pulse" />
                                        Featured Drop
                                    </div>
                                )}
                                {!product.in_stock && (
                                    <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
                                        <span className="font-syne font-bold text-white uppercase tracking-widest">Sold Out</span>
                                    </div>
                                )}
                            </div>
                            <h3 className="font-syne font-bold text-white text-lg tracking-tight mb-1">
                                {product.name}
                            </h3>
                            <p className="font-space text-slate-400">
                                ${product.price.toFixed(2)}
                            </p>
                        </Link>
                    ))}
                </div>

                <Link to="/merch" className="md:hidden mt-8 block">
                    <Button
                        variant="outline"
                        className="w-full bg-transparent border border-white/20 text-white hover:bg-white/10 rounded-none py-4 uppercase tracking-widest"
                    >
                        SHOP ALL MERCH <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                </Link>
            </div>
        </section>
    );
};
